import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const nativeEditorWeb: PluginWebManifest = {
  overviewCards: [
    {
      to: '/org/plugins/native-editor',
      label: 'Native Editor',
      icon: 'Terminal',
      description: 'Open agent devboxes in VS Code, Cursor, or Windsurf.',
      details:
        "Connect your native editor to an agent's devbox via Remote-SSH deep links. One terminal command sets up the SSH key and config, then a single click opens your editor connected to the live devbox workspace.",
      features: [
        '"Open in Editor" chooser in the agent header',
        'Native editor deep links for VS Code, Cursor, and Windsurf',
        'One-step SSH setup command (key + config)',
        'Ephemeral SSH keys via Runloop gateway',
        'Per-agent isolated workspace on the live devbox',
      ],
      group: 'plugins',
    },
  ],
  agentActions: [
    {
      label: 'Open in Editor',
      icon: 'Terminal',
      componentPath: '@reflex/plugin-native-editor/web/NativeEditorButton',
      category: 'environment',
      hideOnMobile: true,
      requiredPermission: 'agents:write',
      requiresAgentWriteAccess: true,
    },
  ],
};
